export default "__VITE_ASSET__366d5db0__"